<template>
    <div class="pageNotice-m">
        <div class="jobMain">
            <div class="mockExam-m">
                <div class="mockExam-mt">
                    <div class="mockExam-mtle"><i class="el-icon-reading"></i> 考务管理 - 模拟练习</div>
                    <div class="mockExam-msubtle">请仔细阅读以下模拟练习说明，按照指引进行操作。</div>
                </div>
                <div class="mockExam-m-content ql-editor" v-html="showObj.content"></div>
                <div class="mockExam-b">
                    <div class="mockExam-btips"><el-checkbox v-model="isRead"></el-checkbox> 已阅读并了解操作流程？</div>
                    <div class="mockExam-bgo">
                        <el-button type="danger" @click="openNewPage" :disabled="!isRead"><i class="el-icon-right"></i> 前往模拟练习页面</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import moment from "moment";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
    name: 'PageMockExam',
    data() {
        return {
            isRead: false,
            showObj: {
                content: '',
                url: 'https://syqy170.qianuni.com/'
            },
        }
    },
    mounted() {
        document.title = '潞安招聘-模拟练习';
        this.verifyEntranceThenLoad();
    },
    methods: {
        resolveEntranceType(user) {
            if (!user) {
                return null;
            }
            if (user.entranceType != null && user.entranceType !== '') {
                return Number(user.entranceType);
            }
            if (user.entrance_type != null && user.entrance_type !== '') {
                return Number(user.entrance_type);
            }
            return null;
        },
        verifyEntranceThenLoad() {
            if (!Cookies.get('reqToKen')) {
                this.$router.push('/pageIndex');
                return;
            }
            axios.get('/zhaopinapi/users/info', {
                headers: {'Authorization': Cookies.get('reqToKen')},
            }).then((res) => {
                const _d = res.data;
                if (!_d.success) {
                    this.$message.error(_d.message || '无法验证入口权限');
                    this.$router.push('/pageRegLink');
                    return;
                }
                if (this.resolveEntranceType(_d.data) !== 2) {
                    this.$message.warning('模拟练习仅对操作人才入口开放');
                    this.$router.push('/pageRegLink');
                    return;
                }
                this.getNotice();
            }).catch(() => {
                this.$router.push('/pageIndex');
            });
        },
        getNotice: function () {
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/announcement/find-latest-by-type/0', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                }).then((res) => {
                    let _d = res.data;
                    if(_d.success) {
                        // console.log(_d)
                        _d.data.createTime = moment(_d.data.createTime).format('yyyy-MM-DD hh:mm:ss');
                        this.showObj.content = _d.data.content;
                        this.showObj.url = _d.data.url;
                    } else {
                        this.$message.error(_d.message);
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
        openNewPage() {
            window.open(this.showObj.url, '_blank');
        }
    }
}
</script>

<style scoped>
    .pageNotice-m{padding: 32px 0;}
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .mockExam-m{border-radius: 10px; border: 1px solid #F3F4F6; background: #fff; box-shadow: 0 0 5px #D1D5DC;}
    .mockExam-mt{padding: 24px; background: #e2001c; color: #fff; border-top-left-radius: 10px; border-top-right-radius: 10px;}
    .mockExam-mtle{font-size: 20px; line-height: 30px; color: #fff;}
    .mockExam-msubtle{font-size: 14px; line-height: 20px; padding-top: 10px; padding-left: 28px;}
    .mockExam-m-content{padding: 32px;}
    .mockExam-b{padding: 24px; background: #f9fafb; border-top: 1px solid #e9e9eb; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; text-align: center;}
    .mockExam-btips{color: #99A1AF; line-height: 30px;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>
